export default __webpack_public_path__ + "static/media/lion.2f2d3a34.svg";